import type { Aop, Territory } from '../types/dashboard';
import { territories } from '../data/territories';

export const territoryById = new Map<string, Territory>(territories.map((t) => [t.id, t] as [string, Territory]));

export const aopById = new Map<string, { aop: Aop; territory: Territory }>();
territories.forEach((t) => t.aops.forEach((a) => aopById.set(a.id, { aop: a, territory: t })));

export const ALL_TERRITORY_IDS = territories.map((t) => t.id);
export const FBC_NAMES = Array.from(new Set(territories.map((t) => t.fbc))).sort();
export const AD_NAMES = Array.from(
  new Set(territories.map((t) => t.ad).filter((x): x is string => Boolean(x)))
).sort();

export function activeTerritoryCount(ids: string[], m: number): number {
  return ids.reduce((n, id) => n + ((territoryById.get(id)?.launchMonth ?? 0) <= m ? 1 : 0), 0);
}

export function activeAopCount(ids: string[], m: number): number {
  return ids.reduce((n, id) => {
    const t = territoryById.get(id);
    return n + (t && t.launchMonth <= m ? t.aops.length : 0);
  }, 0);
}

export function aopZips(aop: Aop): string[] {
  return Array.from({ length: aop.zipCount }, (_, i) => String(aop.zipStart + i * 3).padStart(5, '0'));
}
